import { Inject, Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import type { IRetrieveAlgorithmQuery } from '@protocols/use-cases';

import { AlgorithmDetailState } from '../state/algorithm-detail.state';
import { RETRIEVE_ALGORITHM_QUERY } from './algorithm.effects';
import { tapResponse } from '@ngrx/operators';

@Injectable()
export class AlgorithmDetailEffects {
  constructor(
    private readonly state: AlgorithmDetailState,
    @Inject(RETRIEVE_ALGORITHM_QUERY)
    private readonly retrieveAlgorithmQuery: IRetrieveAlgorithmQuery
  ) {}

  // ============================================================================
  // Re-exposed selectors
  // ============================================================================

  public readonly id$ = this.state.id$;
  public readonly compatibilityInfo$ = this.state.compatibilityInfo$;
  public readonly error$ = this.state.error$;

  // ============================================================================
  // Re-exposed updaters
  // ============================================================================

  public readonly setAlgorithm = this.state.setAlgorithm;
  public readonly reset = this.state.reset;

  // ============================================================================
  // Effects
  // ============================================================================

  public readonly loadAlgorithm = this.state.effect((id$: Observable<string>) =>
    id$.pipe(
      switchMap((id) =>
        from(this.retrieveAlgorithmQuery.execute(id)).pipe(
          tapResponse(
            (algorithm) =>
              this.state.setAlgorithm({
                id: algorithm.id,
                outputLabels: algorithm.outputLabels,
                engine: algorithm.engine,
                deprecated: algorithm.deprecated,
              }),
            (error: Error) =>
              this.state.setError(
                error.message || 'table.algorithms.switch_algorithm_dialog.errors.load_algorithm_compatibility'
              )
          )
        )
      )
    )
  );
}
